/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeeCostsByJobRoleAndLocation } from './EmployeeCostsByJobRoleAndLocation';
import {
    EmployeeCostsByJobRoleAndLocationFromJSON,
    EmployeeCostsByJobRoleAndLocationFromJSONTyped,
    EmployeeCostsByJobRoleAndLocationToJSON,
    EmployeeCostsByJobRoleAndLocationToJSONTyped,
} from './EmployeeCostsByJobRoleAndLocation';

/**
 * 
 * @export
 * @interface ShowEmployeeCostsByJobRoleAndLocationResponse
 */
export interface ShowEmployeeCostsByJobRoleAndLocationResponse {
    /**
     * 
     * @type {EmployeeCostsByJobRoleAndLocation}
     * @memberof ShowEmployeeCostsByJobRoleAndLocationResponse
     */
    data: EmployeeCostsByJobRoleAndLocation;
}

/**
 * Check if a given object implements the ShowEmployeeCostsByJobRoleAndLocationResponse interface.
 */
export function instanceOfShowEmployeeCostsByJobRoleAndLocationResponse(value: object): value is ShowEmployeeCostsByJobRoleAndLocationResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowEmployeeCostsByJobRoleAndLocationResponseFromJSON(json: any): ShowEmployeeCostsByJobRoleAndLocationResponse {
    return ShowEmployeeCostsByJobRoleAndLocationResponseFromJSONTyped(json, false);
}

export function ShowEmployeeCostsByJobRoleAndLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowEmployeeCostsByJobRoleAndLocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeeCostsByJobRoleAndLocationFromJSON(json['data']),
    };
}

  export function ShowEmployeeCostsByJobRoleAndLocationResponseToJSON(json: any): ShowEmployeeCostsByJobRoleAndLocationResponse {
      return ShowEmployeeCostsByJobRoleAndLocationResponseToJSONTyped(json, false);
  }

  export function ShowEmployeeCostsByJobRoleAndLocationResponseToJSONTyped(value?: ShowEmployeeCostsByJobRoleAndLocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeeCostsByJobRoleAndLocationToJSON(value['data']),
    };
}

